// extracted by mini-css-extract-plugin
module.exports = {"heading":"styles_heading__qmfAd","wrapper":"styles_wrapper__YN6LW"};